import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import moment from 'moment'

import {
  FETCH_GAMA_SECTIONS_REQUEST,
  FETCH_GAMA_SECTIONS_SUCCESS,
  FETCH_GAMA_SECTIONS_ERROR,
  SAVE_GAMA_FORM_REQUEST,
  SAVE_GAMA_FORM_SUCCESS,
  SAVE_GAMA_FORM_ERROR,
  FETCH_ALL_GAMA_BY_YEAR_REQUEST,
  FETCH_ALL_GAMA_BY_YEAR_SUCCESS,
  FETCH_ALL_GAMA_BY_YEAR_ERROR,
  RESET_STATE_GAMA
} from 'actionTypes'

export const fetchSections = (token, params) => (dispatch) => {
  dispatch(fetchSectionsRequest())

  return new Api(token, dispatch)
    .post(`${API_URL.GAMA_FILTER}?size=1&page=1`, {
      dsYear: moment().format('YYYY'),
      gamaRegionsBranchsParams: params.gamaRegionsBranchsParams,
      wareHouseId: params.wareHouseId
    })
    .then(dispatch(showSpinner()))
    .then(async (response) => {
      const { gamaSecModels, idGama, ...rest } = response.data

      const ins = await Object.keys(rest).reduce((acc, cur) => {
        if (cur.startsWith('nr')) {
          acc[cur] = rest[cur]
        }

        if (cur.startsWith('in')) {
          acc[cur] = !!rest[cur]
        }

        return acc
      }, [])

      let payload = {
        ...ins,
        idGama,
        gamaSecParams: [],
        gamaSubSecParams: [],
        gamaTypeParams: [],
        gamaSubTypeParams: [],
      }

      gamaSecModels.map((sec) => {
        // Creates section array
        const { id, gamaSubSecModels, ...rest } = sec
        payload = {
          ...payload,
          idGama,
          gamaSecParams: [...payload.gamaSecParams, rest],
        }

        sec.gamaSubSecModels.map((subSec) => {
          // Creates subsection array
          const { id, gamaTypeModels, ...rest } = subSec
          payload.gamaSubSecParams = [...payload.gamaSubSecParams, rest]

          subSec.gamaTypeModels.map((type) => {
            // Creates type array
            const { id, gamaTypeModels, ...rest } = type
            payload.gamaTypeParams = [...payload.gamaTypeParams, rest]

            type.gamaSubTypeModels.map((subType) => {
              // Creates subtype array
              const { id, gamaSubTypeModels, ...rest } = subType
              payload.gamaSubTypeParams = [...payload.gamaSubTypeParams, rest]
            })
          })
        })
      })

      dispatch(fetchSectionsSuccess(payload))
      dispatch(hideSpinner())
    })
    .catch((error) => {

      dispatch(fetchSectionsError(error))
      dispatch(hideSpinner())
    })
}

export const resetStateGama = () => ({
  type: RESET_STATE_GAMA
})

export const resetGama = () => (dispatch) => {
  dispatch(resetStateGama())
}

export const fetchSectionsRequest = () => ({
  type: FETCH_GAMA_SECTIONS_REQUEST,
})

export const fetchAllGamaByYearRequest = () => ({
  type: FETCH_ALL_GAMA_BY_YEAR_REQUEST
})

export const fetchAllGamaByYearSuccess = (data) => ({
  type: FETCH_ALL_GAMA_BY_YEAR_SUCCESS,
  payload: data,
})

export const fetchAllGamaByYearError = (data) => ({
  type: FETCH_ALL_GAMA_BY_YEAR_ERROR,
  payload: data,
})


export const fetchSectionsSuccess = (data) => ({
  type: FETCH_GAMA_SECTIONS_SUCCESS,
  payload: data,
})

export const fetchSectionsError = (error) => ({
  type: FETCH_GAMA_SECTIONS_ERROR,
  payload: error,
})

export const updateGama = (token, args, callBack) => (dispatch) => {
  dispatch(updateGamaRequest())

  return new Api(token, dispatch)
    .post(API_URL.GAMA_SAVE, args)
    .then(dispatch(showSpinner()))
    .then((response) => {
      /* istanbul ignore else */
      if (callBack) {
        callBack()
      }
      dispatch(updateGamaSuccess(response.data))
      dispatch(hideSpinner())

      return response
    })
    .catch((error) => {
      dispatch(updateGamaError(error))
      dispatch(hideSpinner())

      return error
    })
}

export const updateGamaRequest = () => ({
  type: SAVE_GAMA_FORM_REQUEST,
})

export const updateGamaSuccess = (data) => ({
  type: SAVE_GAMA_FORM_SUCCESS,
  payload: data,
})

export const updateGamaError = (error) => ({
  type: SAVE_GAMA_FORM_ERROR,
  payload: { error },
})
